import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-car-line",
    title: "Grúa para turismos",
    desc: "Recogida y traslado de vehículos particulares en las provincias de Lleida y Huesca. Servicio rápido y seguro.",
    image: "https://public.readdy.ai/ai/img_res/d7f64f56aa5d737265962c36ab17279f.jpg",
  },
  {
    icon: "ri-truck-line",
    title: "Vehículos pesados",
    desc: "Grúa especializada para camiones, autobuses y maquinaria pesada. Equipos de gran tonelaje.",
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20tow%20truck%20recovering%20a%20large%20truck%20on%20highway%2C%20professional%20heavy%20vehicle%20recovery%2C%20Spain%2C%20industrial%20photography&width=600&height=380&seq=s2&orientation=landscape",
  },
  {
    icon: "ri-tools-line",
    title: "Asistencia en carretera",
    desc: "Avería, pinchazo, batería descargada o accidente. Estamos donde nos necesitas en el menor tiempo posible.",
    image: "https://readdy.ai/api/search-image?query=roadside%20assistance%20mechanic%20helping%20a%20driver%20with%20a%20broken%20down%20car%20on%20a%20Spanish%20highway%2C%20professional%20service%2C%20daytime&width=600&height=380&seq=s3&orientation=landscape",
  },
  {
    icon: "ri-settings-3-line",
    title: "Transporte de maquinaria",
    desc: "Traslado especializado de maquinaria agrícola e industrial con plataformas y equipos adecuados.",
    image: "https://readdy.ai/api/search-image?query=flatbed%20truck%20transporting%20agricultural%20machinery%20in%20Aragon%20Spain%2C%20professional%20logistics%20transport%2C%20rural%20landscape%2C%20daytime&width=600&height=380&seq=s4&orientation=landscape",
  },
];

export default function ServicesPreview() {
  return (
    <section className="bg-[#f8f7f5] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Lo que hacemos</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a1a1a] mt-3 mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            NUESTROS SERVICIOS
          </h2>
          <div className="w-16 h-1 bg-[#FF6B35] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300 cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-3">
                  <i className={`${s.icon} text-[#FF6B35] text-xl`}></i>
                </div>
                <h3 className="font-bold text-[#1a1a1a] text-base mb-2">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{s.desc}</p>
                <Link
                  to="/servicios"
                  className="text-[#FF6B35] text-sm font-semibold flex items-center gap-1 hover:gap-2 transition-all cursor-pointer"
                >
                  Más información <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 bg-[#1a1a1a] hover:bg-[#FF6B35] text-white font-semibold px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Ver todos los servicios
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
